var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestFitAllColumns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 0H1.8C0.801 0 0 0.801 0 1.8V16.2C0 17.199 0.801 18 1.8 18H16.2C17.199 18 18 17.199 18 16.2V1.8C18 0.801 17.199 0 16.2 0ZM9 1.8L11.7 4.5H9.9V6.3H8.1V4.5H6.3L9 1.8ZM4.5 11.7L1.8 9L4.5 6.3V8.1H6.3V9.9H4.5V11.7ZM9 16.2L6.3 13.5H8.1V11.7H9.9V13.5H11.7L9 16.2ZM13.5 11.7V9.9H11.7V8.1H13.5V6.3L16.2 9",
    fill: "#0096D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestFitAllColumns);
export default __webpack_public_path__ + "static/media/best-fit-all-columns.3e05d0f01bc7f82788f11e6ccfa979bc.svg";
export { ForwardRef as ReactComponent };